import { t, type I18nLocale } from '@ardoq/i18n';
import { showToast, ToastType } from '@ardoq/status-ui';
import type { PptxExportResult } from './exportPresentationToPptx';

export const showPptxExportToast = (
  result: PptxExportResult | 'failed',
  i18nLocale: I18nLocale
): void => {
  if (result === 'empty') {
    showToast(
      t(
        i18nLocale,
        'presentationAdmin:viewer.pptxExport.toast.noSlides',
        'This presentation has no slides to export'
      ),
      ToastType.INFO
    );
  }
  if (result === 'failed') {
    showToast(
      t(
        i18nLocale,
        'presentationAdmin:viewer.pptxExport.toast.failed',
        "Couldn't export the presentation to PPTX"
      ),
      ToastType.ERROR
    );
  }
};
